import React, { useState } from 'react';
import './../../entrydoor.css';

const GrainFilter = ({ value, onChange, label = 'Grain Filter' }) => { // Set default value for childs
    const [selectedGrainFilter, setSelectedGrainFilter] = useState(value || "");

    const handleGrainFilterChange = (e) => {
        const newValue = e.target.value;
        setSelectedGrainFilter(newValue);
        onChange(newValue);
    };

    return (
        <div className="a-container">
            <label htmlFor="GrainFilter">{label}</label>
            <select
                id="GrainFilter"
                value={selectedGrainFilter}
                onChange={handleGrainFilterChange}
            >
              <option value="">{selectedGrainFilter === "None" ? "All ✔" : "All"}</option>
              <option value='Oak'>{selectedGrainFilter === 'Oak' ? 'Oak ✔' : 'Oak'}</option>
              <option value='Fir'>{selectedGrainFilter === 'Fir' ? 'Fir ✔' : 'Fir'}</option>
              <option value='Smooth'>{selectedGrainFilter === 'Smooth' ? 'Smooth ✔' : 'Smooth'}</option>
              <option value='ModernTeak'>{selectedGrainFilter === 'Modern Teak' ? 'Modern Teak ✔' : 'Modern Teak'}</option>
              <option value='BrushStroke'>{selectedGrainFilter === 'Brush Stroke' ? 'Brush Stroke ✔' : 'Brush Stroke'}</option>

            </select>
        </div>
    );
};

export default GrainFilter;
